import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import {
    Dropdown,
    DropdownButton,
    Row as BSRow,
    Table,
} from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { TeeGradeClassStatistic, UserInfo } from '../../../model';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { toast } from 'react-toastify';


const HDID = {
    // Total: -9,
    UnderWeight: -1,
    Healty: 0,
    OverWeight: 1,
    Obesity: 2,
};

const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
    top: borderStyle,
    bottom: borderStyle,
    left: borderStyle,
    right: borderStyle,
} as const;
const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const teeStaticSexNeat: FunctionComponent<Props> = ({ catchErrorForModal }) => {
    const { yearSem, element } = useSemGrade();
    const [datas, setDatas] = useState<TeeGradeClassStatistic[]>([]);
    const [userinfo, setUser] = useState<UserInfo>();
    useEffect(() => {
        if (yearSem) {
            apis.getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(catchErrorForModal);

            toast
                .promise(
                    apis.getTeethTeeStaticSexNeat(yearSem.year, yearSem.sem)
                        .then((r) =>
                            setDatas(r)
                        ),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
        }
    }, [yearSem?.year, yearSem?.sem]);

    const gradeBase = datas.reduce((grades, d) => {
        return { ...grades, [d.grade]: [...(grades[d.grade] || []), d] };
    }, {} as Record<number, TeeGradeClassStatistic[]>);
    const physicalGrades = Array.from(
        new Set(
            Object.values(gradeBase)
                .flat()
                .filter((item) => item.isPhysical)
                .map((item) => item.grade)
        )
    )
        .sort((a, b) => a - b);

    let schoolcount = 0;
    let schoolcountT01 = 0;
    let schoolCountT011 = 0;
    let schoolCountT012 = 0;
    let schoolCountT013 = 0;
    let schoolCountT0123 = 0;
    let countRow = 0;
    const contentRows: Row[] = Object.values(gradeBase).flatMap(
        (gs, idx, allArray) => {
            const rows = gs.flatMap((g, idx) => {
                // 計算資料筆數
                countRow++;
                schoolcount += g.total?.count ?? 0;
                schoolcountT01 += g.total?.countT01 ?? 0;
                schoolCountT011 += g.total?.countT011 ?? 0;
                schoolCountT012 += g.total?.countT012 ?? 0;
                schoolCountT013 += g.total?.countT013 ?? 0;
                schoolCountT0123 += g.total?.countT0123 ?? 0;

                return TeeToRows(
                    g.grade,
                    g.male?.count ?? 0,
                    g.male?.countT01 ?? 0,
                    percent(g.male?.countT01 ?? 0, g.male?.count ?? 0),
                    percent(g.male?.countT0123 ?? 0, g.male?.countT01 ?? 0),
                    g.male?.countT011 ?? 0,
                    g.male?.countT012 ?? 0,
                    g.male?.countT013 ?? 0,
                    g.female?.count ?? 0,
                    g.female?.countT01 ?? 0,
                    percent(g.female?.countT01 ?? 0, g.female?.count ?? 0),
                    percent(g.female?.countT0123 ?? 0, g.female?.countT01 ?? 0),
                    g.female?.countT011 ?? 0,
                    g.female?.countT012 ?? 0,
                    g.female?.countT013 ?? 0,
                    g.total?.count ?? 0,
                    g.total?.countT01 ?? 0,
                    percent(g.total?.countT01 ?? 0, g.total?.count ?? 0),
                    percent(g.total?.countT0123 ?? 0, g.total?.countT01 ?? 0),
                    g.total?.countT011 ?? 0,
                    g.total?.countT012 ?? 0,
                    g.total?.countT013 ?? 0,
                );
            });

            if (datas.length == countRow) {
                rows.push(...TeeToRows(
                    0,
                    0,
                    0,
                    "",
                    "",
                    0,
                    0,
                    0,
                    0,
                    0,
                    "",
                    "",
                    0,
                    0,
                    0,
                    schoolcount ?? 0,
                    schoolcountT01 ?? 0,
                    percent(schoolcountT01 ?? 0, schoolcount ?? 0),
                    percent(schoolCountT0123 ?? 0, schoolcountT01 ?? 0),
                    schoolCountT011 ?? 0,
                    schoolCountT012 ?? 0,
                    schoolCountT013 ?? 0,
                ));
            }
            return rows;
        }
    );

    const content: Row[] = [
        {
            cells: [
                {
                    value: '年級　/ 　性別 ',
                    merge: { column: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '人數',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '初檢齲齒人數A',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '初檢齲齒％',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '齲齒未就醫人數B',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '齲齒複檢正常人數C',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '齲齒複檢異常人數D',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '齲齒複檢％（E）',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
            ],
        },
        ...contentRows,
    ];

    // const workSheet = generateSheet(content, { alignment: cellAlignStyle });
    const handlePrint = () => {
        const printWindow = window.open(
            '',
            '_blank',
            'width=1200,height=900'
        );

        if (!printWindow) {
            alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
            return;
        }

        const escapeHtml = (value: unknown): string => {
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const title =
            `${yearSem?.year}學年第${yearSem?.sem}學期_口腔齲齒複檢結果統計`;

        const tableRows = content
            .map((row) => {
                const cells = row.cells
                    .map((cell) => {
                        if (cell.value === undefined) {
                            return '';
                        }

                        const colSpan = cell.merge?.column
                            ? ` colspan="${cell.merge.column}"`
                            : '';

                        const rowSpan = cell.merge?.row
                            ? ` rowspan="${cell.merge.row}"`
                            : '';

                        return `
                        <td${colSpan}${rowSpan}>
                            ${escapeHtml(cell.value)}
                        </td>
                    `;
                    })
                    .join('');

                return `<tr>${cells}</tr>`;
            })
            .join('');

        printWindow.document.open();

        printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="zh-Hant">
        <head>
            <meta charset="UTF-8" />
            <title>${escapeHtml(title)}</title>

            <style>
                * {
                    box-sizing: border-box;
                }

                html,
                body {
                    margin: 0;
                    padding: 0;
                    font-family:
                        "Microsoft JhengHei",
                        "Noto Sans TC",
                        Arial,
                        sans-serif;
                    color: #000;
                }

                .print-page {
                    min-height: 190mm;
                    display: flex;
                    flex-direction: column;
                }

                h1 {
                    margin: 0 0 10px;
                    text-align: center;
                    font-size: 18px;
                }

                .description {
                    margin-bottom: 6px;
                    font-size: 11px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                }

                td {
                    border: 1px solid #000;
                    padding: 4px 2px;
                    text-align: center;
                    vertical-align: middle;
                    font-size: 10px;
                    word-break: break-word;
                }

                .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

                @page {
                    size: A4 landscape;
                    margin: 8mm;
                }

                @media print {
                    body {
                        padding: 0;
                    }

                    tr {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                }
            </style>
        </head>

        <body>
            <div class="print-page">

                <h1>${escapeHtml(title)}</h1>

                <div class="description">
                    一、A：初檢齲齒人數（未治療齲齒資料代號為 1、2、3）
                </div>

                <div class="description">
                    二、B：齲齒未就醫人數（未治療齲齒資料代號為 1）
                </div>

                <div class="description">
                    三、C：齲齒複檢正常人數（未治療齲齒資料代號為 2）
                </div>

                <div class="description">
                    四、D：齲齒複檢異常人數（未治療齲齒資料代號為 3）
                </div>

                <div class="description">
                    五、E：齲齒複檢％（(C + D) / A）
                </div>

                <table>
                    <tbody>
                        ${tableRows}
                    </tbody>
                </table>

               <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>

            </div>

            <script>
                window.onload = function () {
                    window.focus();

                    setTimeout(function () {
                        window.print();
                    }, 300);
                };

                window.onafterprint = function () {
                    window.close();
                };
            </script>
        </body>
        </html>
    `);

        printWindow.document.close();
    };

    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <span className="mr-3">{element}</span>
                {physicalGrades.length > 0 && (
                    <span style={{ color: 'red' }}>
                        ※ 提示：{physicalGrades.join('、')} 年級的資料來自健檢口腔資料
                    </span>
                )}
                <DropdownButton
                    id="tee-static-sex-neat-export"
                    title="匯出"
                    variant="success"
                    disabled={!datas.length}
                >
                    <Dropdown.Item
                        onClick={() => {
                            const workSheet = generateSheet(
                                [
                                    {
                                        cells: [
                                            {
                                                value: `${yearSem?.year}學年第${yearSem?.sem}學期_口腔齲齒複檢結果統計`,
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '一、A：初檢齲齒人數（未治療齲齒資料代號為 1、2、3）',
                                                merge: { column: 7 },
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '二、B：齲齒未就醫人數（未治療齲齒資料代號為 1）',
                                                merge: { column: 7 },
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '三、C：齲齒複檢正常人數（未治療齲齒資料代號為 2）',
                                                merge: { column: 7 },
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '四、D：齲齒複檢異常人數（未治療齲齒資料代號為 3）',
                                                merge: { column: 7 },
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '五、E：齲齒複檢％ （ (C + D)/A）',
                                                merge: { column: 7 },
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    ...content,
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                                                style: {
                                                    alignment: {
                                                        horizontal: 'left',
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                ],
                                {
                                    alignment: cellAlignStyle,
                                }
                            );

                            downloadSheets(
                                '口腔齲齒複檢結果統計',
                                userinfo?.exportFileType,
                                {
                                    sheet: workSheet,
                                    name: 'st',
                                }
                            );
                        }}
                    >
                        Excel 下載
                    </Dropdown.Item>

                    <Dropdown.Item onClick={handlePrint}>
                        列印
                    </Dropdown.Item>
                </DropdownButton>
            </BSRow>
            <hr />
            <BSRow>
                <Table
                    striped
                    bordered
                    className="text-center"
                    style={{ tableLayout: 'fixed' }}
                >
                    <colgroup>
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                    </colgroup>
                    <tbody>
                        {content.map((r, i) => {
                            const cells = r.cells.map((c, j) =>
                                c.value != undefined ? (
                                    <td
                                        colSpan={c.merge?.column}
                                        rowSpan={c.merge?.row}
                                        key={`${i}-${j}`}
                                    >
                                        {c.value}
                                    </td>
                                ) : (
                                    <Fragment key={`${i}-${j}`}></Fragment>
                                )
                            );
                            return <tr key={i}>{cells}</tr>;
                        })}
                    </tbody>
                </Table>
            </BSRow>
        </AuthedLayout>
    );
};

function TeeToRows(
    grade: number,
    maleCount: number,
    maleCountT01: number,
    maleRate: string,
    maleRateT0123: string,
    maleCountT011: number,
    maleCountT012: number,
    maleCountT013: number,
    femaleCount: number,
    femaleCountT01: number,
    femaleRate: string,
    femaleRateT0123: string,
    femaleCountT011: number,
    femaleCountT012: number,
    femaleCountT013: number,
    totalCount: number,
    totalCountT01: number,
    totalRate: string,
    totalRateT0123: string,
    totalCountT011: number,
    totalCountT012: number,
    totalCountT013: number,
): Row[] {
    let returnhtml;
    const gradeNo = [
        {
            value: grade,
            merge: { row: 3 },
            style: { border: fullBorderStyle },
        }
    ];
    if (grade != 0) {
        returnhtml = [
            {
                cells: [
                    ...gradeNo,
                    {
                        value: "男",
                        merge: { row: 1 }
                    },
                    {
                        value: maleCount,
                    },
                    {
                        value: maleCountT01,
                    },
                    {
                        value: maleRate,
                    },
                    {
                        value: maleCountT011,
                    },
                    {
                        value: maleCountT012,
                    },
                    {
                        value: maleCountT013,
                    },
                    {
                        value: maleRateT0123,
                    },
                ],

            },
            {
                cells: [
                    {
                        style: { border: fullBorderStyle },
                    },
                    {
                        value: "女",
                        merge: { row: 1 }
                    },
                    {
                        value: femaleCount,
                    },
                    {
                        value: femaleCountT01,
                    },
                    {
                        value: femaleRate,
                    },
                    {
                        value: femaleCountT011,
                    },
                    {
                        value: femaleCountT012,
                    },
                    {
                        value: femaleCountT013,
                    },
                    {
                        value: femaleRateT0123,
                    },
                ],

            },
            {
                cells: [
                    {
                        style: { border: fullBorderStyle },
                    },
                    {
                        value: "小計",
                        merge: { row: 1 }
                    },
                    {
                        value: totalCount,
                    },
                    {
                        value: totalCountT01,
                    },
                    {
                        value: totalRate,
                    },
                    {
                        value: totalCountT011,
                    },
                    {
                        value: totalCountT012,
                    },
                    {
                        value: totalCountT013,
                    },
                    {
                        value: totalRateT0123,
                    },
                ],

            },
        ]
    } else {
        returnhtml = [
            {
                cells: [
                    {
                        value: "總計",
                        merge: { column: 2 }
                    },
                    {
                        value: totalCount,
                    },
                    {
                        value: totalCountT01,
                    },
                    {
                        value: totalRate,
                    },
                    {
                        value: totalCountT011,
                    },
                    {
                        value: totalCountT012,
                    },
                    {
                        value: totalCountT013,
                    },
                    {
                        value: totalRateT0123,
                    },
                ],

            },

        ]
    }
    return returnhtml;
}

function percent(value: number, denominator: number): string {
    if (!denominator) return '0.00%';
    return ((value / denominator) * 100).toFixed(2) + '%';
}
export const TeeStaticSexNeat = connector(teeStaticSexNeat);
